//
// MeasureValueInfo.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../../models/BIRDModel";
import "./DataDefinitionFilterRangeOperator";

var MeasureValueInfo = createModule("BIRD::MeasureValueInfo", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        minValue: 6,
        maxValue: 6,
        filterAggregatedValues: 2,
        minAggregatedValue: 6,
        maxAggregatedValue: 6,
        formatName: 7,
        filterMax: 6,
        filterMin: 6,
        rangeOperator: 4,
    },
    ,
    ,
    ,
    ,
    ,
]);
export default MeasureValueInfo;
